import React from 'react';
import {
  Layout, Row, Col, message,  Button
} from 'antd';

import img from '../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../util/api';
import moment from 'moment';
const { Content } = Layout;
class Subscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscription: [],
      visbale: false,
      onvisbale: false,


    }
    this.api = new MiCompAPI(this.props.userPermandMasters);

  }
  componentDidMount() {
    this.api.invoke("GetUserSubscriptions", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            subscription: data.data
          })
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
      else {
      }
    });
  }
  handleSubmit = (e) => {

  }
  render() {
    const {  Permissions, SubscriptionEndDate, SubscriptionStartDate } = this.props.userPermandMasters;
    return (
      <Content>
        <div className="mi_main_div" >
          <div className="mi_box" style={{ margin: "10px", marginTop: '20px' }}>
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">
                  Subscription</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
              </Col>
            </Row>
          </div>
          <div className="mi_main">
            <p className='mi_title' style={{ color: '#fd828d' }}>Subscription</p>
            <Row span={24}>
              <Col md={4} sm={24}>
                <p className="mi_name">Subscription</p>
                <p className="mi_value">{Permissions && Permissions[0].subscription_Type}</p>
              </Col>

              <Col md={4} sm={24}>
                <p className="mi_name">Start Date </p>
                <p className="mi_value">{SubscriptionStartDate ? moment(SubscriptionStartDate).format("MM/DD/YYYY") : ''}</p>
              </Col>
              <Col md={4} sm={24}>
                <p className="mi_name">End Date</p>
                <p className="mi_value">{SubscriptionEndDate ? moment(SubscriptionEndDate).format("MM/DD/YYYY") : ''}</p>
              </Col>
              <Col md={4} sm={24}>
                <p className="mi_name">Plan</p>
                <p className="mi_value">{SubscriptionEndDate && moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 28 ? "Monthly" : SubscriptionEndDate && moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 365 ? 'Annual' : ""}</p>
              </Col>

              <Col md={4} sm={24}>
                <p className="mi_name"></p>
                <p className="mi_value"><span >{(!SubscriptionEndDate || (moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 28 && moment(SubscriptionEndDate).diff(moment(), "days") <= 5) ||
                  (moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 365 && moment(SubscriptionEndDate).diff(moment(), "days") <= 28)) ? <Button onClick={() => { this.setState({ visbale: true }) }} type='primary'>Renew </Button> : ""}</span> </p>
              </Col>
              {/* <Col md={4} sm={24}>
                <p className="mi_name"></p>
                <p className="mi_value"> <Button onClick={() => {this.setState({visbale:true})}} type='primary'>Update </Button>  </p>
              </Col> */}
            </Row>
          </div>
          <Row>
            {this.state.visbale && this.state.subscription.map(x => {
              return <Col md={8}>

                <div className="mi_main" style={{ border: '1px solid #4552B6', borderRadius: '10px', padding: '20px', textAlign: 'center' }}>
                  <Row>
                    <Col sm={24}>
                      <span style={{ color: '#2552B6', fontSize: '24px', fontWeight: 'bold' }}>{x.subscription_Type} </span>
                      <span >{x.subscription_Type === Permissions[0].subscription_Type && SubscriptionEndDate && moment(SubscriptionEndDate) > moment() ? <i style={{ color: '#39b54a' }} className="fa fa-check-circle"></i> : ""}</span>                      <br></br>
                      <span >{x.subscription_Type === Permissions[0].subscription_Type && SubscriptionEndDate ? "End date :" + moment(SubscriptionEndDate).format("MM/DD/YYYY") : ""}</span>                      <br></br>

                      <span style={{ color: '#2552B6', fontSize: '66px', fontWeight: 'bold' }}><span style={{ fontSize: '30px', verticalAlign: 'super' }}>$</span>{x.price === 0 ? 'Free' : x.price} <span style={{ fontSize: '15px', verticalAlign: 'super' }}>{x.price === 0 ? '' : 'per month'}</span></span>
                      <br></br>

                    </Col>
                    <Col sm={24}>
                      {x.subscription_Types.map((y, i) => {
                        if (i < 2 || this.state.onvisbale)
                          return <Row>
                            <Col sm={24}>
                              <p style={{ background: '#dadeff', color: '#2552B6', padding: '3px 0px', fontSize: '18px', fontWeight: 'bold' }}>{y.subscription_Type}</p>
                              {y.permissions.map((z, j) => {
                                if (j < 2 || this.state.onvisbale)
                                  return <Row>
                                    <Col sm={24}>
                                      <p style={{ textAlign: 'left', fontSize: '20px', fontWeight: 'bold' }}>{z.access ? <i style={{ color: '#39b54a' }} className="fa fa-check-circle"></i> : <i style={{ color: 'red' }} className="fa fa-times-circle"></i>} {z.subscription_Role}</p>
                                      {z.permissions.map((l) => {
                                        return <Row>
                                          <Col sm={24}>
                                            <p style={{ marginLeft: '30px', textAlign: 'left', fontSize: '20px', fontWeight: 'bold' }}>{l.access ? <i style={{ color: '#39b54a' }} className="fa fa-check-circle"></i> : <i style={{ color: 'red' }} className="fa fa-times-circle"></i>}{l.subscription_Role}</p>
                                          </Col>
                                        </Row>
                                      })}
                                    </Col>
                                  </Row>
                              })}
                            </Col>
                          </Row>
                      })}
                    </Col>
                    <Col sm={24}>
                      <span > <Button style={{ width: '100%', marginBottom: '20px' }} type='default' onClick={() => { this.setState({ onvisbale: !this.state.onvisbale }) }}>{!this.state.onvisbale ? "More" : "Less"}</Button> </span>                     
                      <span >{x.price !== 0 && (!SubscriptionEndDate || (moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 28 && moment(SubscriptionEndDate).diff(moment(), "days") <= 5)) ? <Button style={{ width: '100%' }} onClick={() => this.props.history.push(
                        {
                          pathname: '/subpayment',
                          state: { subscription_Type: x.subscription_Type, price: x.price, days: x.minDuration }
                        })} type='primary'>Go {x.subscription_Type} Monthly</Button> : ""}</span>                     
                      <span >{x.price !== 0 && (!SubscriptionEndDate || (moment(SubscriptionEndDate).diff(moment(SubscriptionStartDate), "days") === 365 && moment(SubscriptionEndDate).diff(moment(), "days") <= 28) ) ? <Button style={{ width: '100%', marginTop: '20px' }} onClick={() => this.props.history.push(
                        {
                          pathname: '/subpayment',
                          state: { subscription_Type: x.subscription_Type, price: Math.round((x.price * 12) - (x.price * 12) * .2, 2), days: x.maxDuration }
                        })} type='primary'>Go {x.subscription_Type} Yearly (20% Discount)</Button> : ""}</span>
                    </Col>
                  </Row>
                </div>
              </Col>
            })}</Row>
        </div>
      </Content>
    );
  }
}
export default Subscription;